/* Floating header behavior (homepage only).
   - Overlays the first section by pulling #MainContent up under the header.
   - Idle at the top = a floating inset card (.header-wrapper-floating).
   - Docks to the standard full-width header on scroll past the header and when a
     MEGA MENU or the MOBILE DRAWER opens (so those attach flush to a full-width
     header). Simple dropdowns do NOT dock — they drop beneath the floating header.
     Hover docking is optional via data-floating-activation="hover".
   Self-contained: only runs when a [data-floating-header] wrapper exists, so it
   never affects the standard or transparent header. */
(function () {
  function init() {
    var wrapper = document.querySelector('.header-wrapper[data-floating-header]');
    if (!wrapper) return;
    var header = document.getElementById('site-header');
    var main = document.getElementById('MainContent');
    if (!header || !main) return;

    main.classList.add('has-site-header-floating');

    var cachedOffset = null;

    function rootFontPx() {
      var v = parseFloat(window.getComputedStyle(document.documentElement).fontSize);
      return isNaN(v) ? 16 : v;
    }
    function cssLengthToPx(value) {
      value = (value || '').trim();
      if (value.slice(-3) === 'rem') return parseFloat(value) * rootFontPx();
      if (value.slice(-2) === 'px') return parseFloat(value);
      var n = parseFloat(value);
      return isNaN(n) ? 0 : n;
    }
    // Read the TARGET top inset from the --floating-top variable, NOT the live
    // computed margin-top (which animates during float <-> dock and would read a
    // transient ~0 mid-animation).
    function topMargin() {
      return cssLengthToPx(window.getComputedStyle(wrapper).getPropertyValue('--floating-top'));
    }
    function atTop() {
      return (window.pageYOffset || document.documentElement.scrollTop) <= header.offsetHeight;
    }
    // A desktop mega menu is open (its panel uses position:fixed; top:var(--header-bottom)).
    function megaMenuOpen() {
      return !!wrapper.querySelector('.header__inline-menu details[open] .mega-menu');
    }
    function drawerOpen() {
      var d = document.querySelector('#Details-menu-drawer-container');
      return !!(d && d.open);
    }
    // Dock only for surfaces that need to attach to the full-width header: the mega
    // menu and the mobile drawer. Simple dropdowns keep the header floating.
    function shouldDock() {
      return megaMenuOpen() || drawerOpen();
    }
    // When docked, the card's top inset is gone, so keep the shared header-bottom
    // variables (used by the mega menu's fixed top, the drawer height, and
    // predictive-search anchoring) in sync with the now full-width header bottom.
    function syncHeaderBottom() {
      var b = Math.round(header.getBoundingClientRect().bottom);
      document.documentElement.style.setProperty('--header-bottom-position', b + 'px');
      document.documentElement.style.setProperty('--header-bottom', b + 'px');
    }
    function update() {
      var floating = atTop() && !shouldDock();
      if (floating) {
        wrapper.classList.add('header-wrapper-floating');
        // Measure the overlay offset only while floating (so the card's top inset
        // is included), then reuse it when docked so page content doesn't jump.
        cachedOffset = wrapper.offsetHeight + topMargin();
      } else {
        wrapper.classList.remove('header-wrapper-floating');
        syncHeaderBottom();
      }
      if (cachedOffset != null) {
        main.style.setProperty('--floating-offset', '-' + cachedOffset + 'px');
      }
    }

    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);

    // The float -> dock margin transition runs for 0.3s; the syncHeaderBottom()
    // call inside update() fires at the START of it, so --header-bottom is captured
    // at the still-floating position. Re-sync once the transition settles so the
    // mega menu (top: var(--header-bottom)) lands flush against the docked header.
    wrapper.addEventListener('transitionend', function (e) {
      if (e.propertyName === 'margin-top' && !wrapper.classList.contains('header-wrapper-floating')) {
        syncHeaderBottom();
      }
    });

    // Dock when desktop dropdowns / mega menus open (only mega menus actually dock,
    // via shouldDock(); observing all of them keeps the state correct on close too).
    wrapper.querySelectorAll('.header__inline-menu details').forEach(function (d) {
      new MutationObserver(update).observe(d, { attributes: true, attributeFilter: ['open'] });
    });
    // Dock when the mobile menu drawer opens. Sync header-bottom AFTER the theme's
    // own handler runs so the drawer uses the docked (full-width) header bottom.
    var drawer = document.querySelector('#Details-menu-drawer-container');
    if (drawer) {
      new MutationObserver(function () {
        update();
        if (drawer.open) requestAnimationFrame(syncHeaderBottom);
      }).observe(drawer, { attributes: true, attributeFilter: ['open'] });
    }

    // Optional hover docking
    if ((wrapper.dataset.floatingActivation || 'interaction') === 'hover') {
      wrapper.addEventListener('mouseenter', function () {
        if (atTop()) { wrapper.classList.remove('header-wrapper-floating'); syncHeaderBottom(); }
      });
      wrapper.addEventListener('mouseleave', function () {
        if (atTop() && !shouldDock()) wrapper.classList.add('header-wrapper-floating');
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // Live preview in the theme editor
  document.addEventListener('shopify:section:load', init);
})();
